import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKoFiComponent } from './simple-icons-ko-fi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKoFiComponent ],
    exports:      [ SimpleIconsKoFiComponent ],
    bootstrap:    []
})
export class SimpleIconsKoFiModule {}
